import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Soft%20elegant%20fashion%20retail%20concept%20with%20curated%20clothing%20pieces%20and%20accessories%20arranged%20artfully%20on%20warm%20cream%20backdrop%2C%20subtle%20pastel%20gradient%2C%20gentle%20geometric%20abstract%20shapes%20blending%20into%20background%2C%20light%20airy%20atmosphere%2C%20modern%20clean%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20sophisticated%20editorial%20quality%20suitable%20for%20website%20hero&width=1600&height=900&seq=hero-main-2026&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 py-16 md:py-20">
        <span className="inline-block px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium mb-5 tracking-wide">
          #1 OOPBuy Spreadsheet Guide 2026
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white max-w-3xl mx-auto leading-tight">
          Der ultimative <strong className="font-bold">OOPBuy Spreadsheet</strong> Guide
        </h1>
        <p className="mt-4 text-base md:text-lg text-white/85 max-w-xl mx-auto leading-relaxed">
          Entdecke die besten OOPBuy Spreadsheets für Schuhe, Kleidung und Accessoires. 
          Alle Kategorien, Tipps und Tricks auf einen Blick.
        </p>

        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-7 py-3 rounded-lg text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/30"
          >
            OOPBuy Spreadsheet &rarr;
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-7 py-3 rounded-lg text-sm font-semibold bg-white/15 backdrop-blur-sm text-white border border-white/30 hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
          >
            Buy It Now &rarr;
          </a>
          <Link
            to="/artikel/oopbuy-spreadsheet-guide"
            className="w-full sm:w-auto px-7 py-3 rounded-lg text-sm font-semibold text-white/90 hover:text-white hover:underline transition-all cursor-pointer whitespace-nowrap"
          >
            Zum Guide &darr;
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-3 gap-4 max-w-md mx-auto">
          {[
            { num: '500+', label: 'Spreadsheets' },
            { num: '14', label: 'Kategorien' },
            { num: '9', label: 'SEO Guides' },
          ].map((stat) => (
            <div key={stat.label} className="text-white">
              <div className="font-heading text-2xl md:text-3xl font-bold">{stat.num}</div>
              <div className="text-xs text-white/70 mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}